import React, { useEffect, useState } from 'react';
import { withCookies, Cookies, ReactCookieProps } from 'react-cookie';
import { shallowEqual, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { RootState } from 'modules';
import moment from 'moment';
import PopUpDC from 'PopUpDC';
import apiClient, { WrappingApiClient } from 'libs/api/apiClient';
import { ERoute } from 'enums/route.enum';
import { Modal, Button, Row, Checkbox } from 'antd';
import { ArrowRightOutlined } from '@ant-design/icons';
import styled from 'styled-components';
import { device } from 'GlobalStyles';
import ExitImg from 'assets/icons/exit.svg';
import ticket from 'assets/images/pages/ticket/extendTicket.webp';

interface ICookieProps extends ReactCookieProps {}
type TUserRate = {
  completed_rate: number;
  my_correct_rate: number;
  top_10_correct_rate: number;
};

const ExtendModal = (props: ICookieProps) => {
  const currentUser = useSelector((state: RootState) => state.user.current_user, shallowEqual);
  const [isChecked, setIsChecked] = useState<boolean>(false);
  const [cookies, setCookies] = useState<Cookies | undefined>(props.cookies);
  const [showModal, setShowModal] = useState(false);
  const [hasCookies, setHasCookies] = useState<boolean>(false);

  const [userRate, setUserRate] = useState<TUserRate>({
    completed_rate: 0,
    my_correct_rate: 0,
    top_10_correct_rate: 0,
  });
  const [purchaseDrillPassDate, setPurchaseDrillPassDate] = useState<number>();

  const TOP_10_RATE: number = 63;

  const getExtendDrillPassDate = () => {
    let date = moment(currentUser?.drill_membership_start_at)
      .add(90, 'days')
      .diff(`${moment().year()}-${moment().month() + 1}-${moment().date()}`, 'days');

    if (date <= 8 && date >= 1) {
      setPurchaseDrillPassDate(date - 1);
    }
  };

  useEffect(() => {
    getExtendDrillPassDate();
  }, []);

  const getExtendPassToServer = () => {
    return WrappingApiClient(apiClient.get('/drill/user/rate'));
  };

  const getExtendPass = async () => {
    const { data }: any = await getExtendPassToServer();

    const percent = {
      completed_rate: Math.floor(data['completed_rate'] * 100),
      my_correct_rate: Math.floor(data['my_correct_rate'] * 100),
      top_10_correct_rate: Math.floor(data['top_10_correct_rate'] * 100),
    };

    setUserRate(percent);
  };

  useEffect(() => {
    currentUser && getExtendPass();

    if (cookies) {
      if (purchaseDrillPassDate !== undefined && purchaseDrillPassDate >= 0) {
        const currentCookies = cookies.get(PopUpDC.EXTEND_QUIZ_SUBCRIBTION_COOKIE_VALUE);
        setShowModal(!currentCookies);
        setHasCookies(!!currentCookies);
      }
    } else {
      setCookies(props.cookies);
    }
  }, [props.cookies, purchaseDrillPassDate]);

  const closeModal = () => {
    if (cookies) {
      if (isChecked) {
        const expires: Date = moment(currentUser?.drill_membership_start_at)
          .add(30, 'days')
          .toDate();
        cookies.set(PopUpDC.EXTEND_QUIZ_SUBCRIBTION_COOKIE_VALUE, true, {
          path: '/',
          expires,
        });
      }
    }
    setShowModal(false);
  };

  const onCloseModal = () => {
    closeModal();
  };

  const onCheck = (e: any) => {
    setIsChecked(e.target.checked);
  };

  return (
    <Modal
      visible={showModal}
      centered={true}
      closable={false}
      width={655}
      bodyStyle={{ marginBottom: '12px' }}
      footer={
        <>
          <BottomBtns>
            <Link to={`${ERoute.MentoringProgramAbout}?field=consulting`}>
              <Button style={{ marginTop: '10px' }}>Mock Interview 알아보기</Button>
            </Link>
            <div style={{ marginTop: '10px' }}>
              <Button onClick={onCloseModal} style={{ marginRight: '10px' }}>
                닫기
              </Button>
              {userRate?.my_correct_rate > TOP_10_RATE && (
                <Link to={ERoute.CaseIntroduction}>
                  <Button type='primary'>케이스 노트 알아보기</Button>
                </Link>
                // 연장 당분간 비활성화
                // ) : (
                //   <Link to={ERoute.CSLearningPurchasePage}>
                //     <Button type="primary">3개월 연장하기</Button>
                //   </Link>
                // )}
              )}
            </div>
          </BottomBtns>
          <Row style={{ marginTop: '5px', justifyContent: 'end' }}>
            <Checkbox className='checkbox-text' onChange={onCheck}>
              남은 만료기간까지 보지 않기
            </Checkbox>
          </Row>
        </>
      }
    >
      <Row justify='space-between'>
        <ModalTitle>
          {purchaseDrillPassDate === 0
            ? '금일 24시에 Career Step 패스가 만료됩니다'
            : `Career Step 패스 만료 ${purchaseDrillPassDate}일 전`}
        </ModalTitle>
        <img
          src={ExitImg}
          style={{
            width: '32px',
            height: '32px',
            padding: '8px',
            backgroundColor: '#F0F8F6',
            borderRadius: '8px',
            cursor: 'pointer',
          }}
          alt=''
          onClick={(prev) => setShowModal(!prev)}
        />
      </Row>

      <div style={{ marginTop: '16px', fontSize: '14px', textAlign: 'center' }}>
        내 완료율: {userRate?.completed_rate}%
      </div>
      <div style={{ fontSize: '24px', textAlign: 'center' }}>내 정답률: {userRate?.my_correct_rate}%</div>
      <div style={{ margin: '16px 0', fontSize: '14px', textAlign: 'center' }}>
        지난시즌 MBB 합격자의 평균 정답률은{' '}
        {userRate?.top_10_correct_rate < TOP_10_RATE ? TOP_10_RATE : userRate?.top_10_correct_rate}
        %입니다
        <br />
        {userRate?.my_correct_rate < TOP_10_RATE
          ? '33% 할인된 가격으로 새롭게 추가되는 문제들과 함께 정답률을 올려보세요'
          : 'MBB 합격자의 대부분은 케이스 노트를 통해 케이스 노하우를 터득합니다'}
      </div>
      {userRate?.my_correct_rate < TOP_10_RATE && (
        <>
          <div style={{ textAlign: 'center', marginBottom: '16px' }}>
            연장 필요 시 멘토님의 만료일{' '}
            {`(${moment(currentUser?.drill_membership_start_at)
              .add(30, 'days')
              .year()}년 ${moment(currentUser?.drill_membership_start_at)
              .add(30, 'days')
              .month() + 1}월 ${moment(currentUser?.drill_membership_start_at)
              .add(30, 'days')
              .date()}일)`}{' '}
            이후에 <br />
            케이스 문제 <ArrowRightOutlined /> 문제 선택 <ArrowRightOutlined /> 채점하기 클릭 후 Career Step
            패스 결제바랍니다
          </div>
          <div style={{ width: '100%', marginBottom: '16px', textAlign: 'center' }}>
            <img src={ticket} alt='' />
          </div>
        </>
      )}
      <div style={{ fontSize: '14px', textAlign: 'center' }}>
        케이스 문제를 실제 인터뷰에 활용해보고 싶다면?
        <br />
        Mock Interview로 실전감각을 키워보세요
      </div>
    </Modal>
  );
};

export default withCookies(ExtendModal);

const ModalTitle = styled.div`
  font-size: 28px;
  font-weight: 700;

  @media screen and ${device.md} {
    font-size: 20px;
  }

  @media screen and ${device.xs} {
    font-size: 14px;
    line-height: 30px;
  }
`;

const BottomBtns = styled.div`
  display: flex;
  justify-content: space-between;

  @media screen and ${device.xs} {
    flex-direction: column;
  }
`;
